import { SET_ALL_PAGE } from 'root/src/client/logic/list/actionIds'

export default (allPage, moduleId) => ({
	type: SET_ALL_PAGE,
	payload: { allPage, moduleId },
})
